import { canUseDOM } from "~/lib/dom";

export function isProduction() {
  if (!canUseDOM()) return false;
  const location = new URL(window.location.href);
  return location.hostname === "node.sonic.game";
}
